import { Star, Target, Medal, Crown, Trophy, type LucideIcon } from 'lucide-react';

export interface BadgeMeta {
  name: string;
  icon: LucideIcon;
  description: string;
}

export const BADGE_META: Record<string, BadgeMeta> = {
  first_week:          { name: "Primera Semana",   icon: Star,   description: "7 días consecutivos" },
  consistent:          { name: "Constante",        icon: Target, description: "14 días consecutivos" },
  dedicated:           { name: "Dedicado",         icon: Medal,  description: "30 días consecutivos" },
  legend:              { name: "Leyenda",          icon: Crown,  description: "60 días consecutivos" },
  first_project:       { name: "Primer Proyecto",  icon: Star,   description: "Creaste tu primer proyecto" },
  first_certification: { name: "Certificado",      icon: Trophy, description: "Obtuviste tu primera certificación" },
};

const humanize = (key: string) =>
  key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export function getBadgeMeta(key: string): BadgeMeta {
  return BADGE_META[key] ?? { name: humanize(key), icon: Trophy, description: '' };
}
